import {
  SHTableCell,
  SHTableCellProps,
  SHTypography,
} from "@components/design-systems";
import { useTheme } from "@mui/material";

interface SummaryCommentHeaderCellProps extends SHTableCellProps {
  children: React.ReactNode;
}
export const SummaryCommentHeaderCell = ({
  children,
  ...others
}: SummaryCommentHeaderCellProps) => {
  const { palette } = useTheme();
  
  return (
    <SHTableCell
      sx={{
        height: "50px",
        borderLeft: `solid 1px ${palette.divider}`,
      }}
      {...others}
    >
      <SHTypography
        variant="subtitle1"
        fontWeight={700}
        textAlign="center"
        lineHeight={"120%"}
      >
        {children}
      </SHTypography>
    </SHTableCell>
  );
};
